export default __webpack_public_path__ + "static/media/discord.bf460473.svg";